import React from 'react';

let inlineBlockStyle = {
  display: 'inline-block'
}

export const MatchAccountMoreThanTwenty = () => (
	<div className="top-error">
	  <div className="dx-col">
	    <div>
	      To make a payment on any of your other Billing Accounts, <br />
	      either log in using that account number or call us at <span style={inlineBlockStyle}>1-888-978-5371 (Mon - Fri, 8 am to 8:30 pm ET).</span>
	    </div>
	  </div>
	</div>
)

export const NoMatchLessThanTwenty = () => (
	<div className="top-error">
		<div className="dx-col">
		<div>
			We are having trouble locating the account. <br />
			Please try again, or call our customer help line at <span style={inlineBlockStyle}>1-888-978-5371 (Mon - Fri, 8 am to 8:30 pm ET).</span>
		</div>
		</div>
	</div>
)

export const NoMatchMoreThanTwenty = () => (
	<div className="top-error">
	<div className="dx-col">
	<div>
	We are unable to locate the Billing Account you entered. <br />
	Please call us at <span style={inlineBlockStyle}>1-888-978-5371 (Mon - Fri, 8 am to 8:30 pm ET).</span>
	</div>
	</div>
	</div>
)



// WEBPACK FOOTER //
// ./src/components/atomic/pages/AccountsPage/PaymentMessages.js